import styled from 'styled-components'
import { device } from 'Rentlio/style/responsive'

export const FormTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  @media ${device.tablet} {
    gap: 12px;
  }
`

export const FormLabel = styled.div`
  text-transform: uppercase;
  color: ${props => props.theme.colors.lightText};
  font-size: ${props => props.theme.fonts._12};
  line-height: ${props => props.theme.fonts._14};
  margin-bottom: 10px;
  white-space: nowrap;
`

export const FormRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: ${({ marginBottom }) => marginBottom || 40}px;

  @media ${device.mobile} {
    margin-bottom: 0;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const FormGroup = styled.div`
  width: 100%;
  ${props => (props.fullWidth ? '' : 'max-width: 280px')};
  margin-left: 15px;
  margin-right: 15px;

  :first-child {
    margin-left: 0;
  }

  :last-child {
    margin-right: 0;
  }

  @media ${device.mobile} {
    margin: 0;
    max-width: 100%;
    margin-bottom: 20px;
  }
`

export const CreditCardRow = styled(FormRow)`
  ${FormGroup} {
    flex-basis: 20%;

    :first-child {
      flex-basis: 50%;
    }

    :last-child {
      flex-basis: 20%;

      @media ${device.laptop} {
        flex-basis: 40%;
      }
    }
  }
`

export const MonriRow = styled(FormRow)`
  margin-right: 25px;

  @media ${device.laptop} {
    margin-right: 0px;
  }
`

export const FormError = styled.div`
  color: ${({ theme }) => theme.colors.alertColor};
  font-size: ${({ theme }) => theme.fonts._14};
  line-height: ${({ theme }) => theme.fonts._18};
  padding-top: 10px;
  padding-bottom: 10px;
`
